import {Injectable} from '@angular/core';
import {
  NzNotificationRef,
  NzNotificationService
} from 'ng-zorro-antd/notification';
import {NzNotificationDataOptions} from 'ng-zorro-antd/notification/typings';
import moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  duration = 7000;

  constructor(private notification: NzNotificationService) {
  }

  /**
   * Handle ambiguous responses like responses from the server so that toasts can be created on the fly
   * @param type
   * @param title
   * @param message
   * @param duration
   */
  response(type, title, message?, duration = this.duration) {
    return this.notification.create(type, title, message, {
      nzKey: this.createKey(title + message),
      nzDuration: parseInt(duration.toString(), 10)
    });
  }

  success(title, message?, duration = this.duration) {
    return this.notification.success(title, message, {
      nzKey: this.createKey(title + message),
      nzDuration: duration
    });
  }

  error(title, message?, duration = this.duration) {
    return this.notification.error(title, message, {
      nzKey: this.createKey(title + message),
      nzDuration: duration
    });
  }

  warning(title, message?, duration = this.duration) {
    return this.notification.warning(title, message, {
      nzKey: this.createKey(title + message),
      nzDuration: duration
    });
  }

  info(title, message?, duration = this.duration) {
    return this.notification.info(title, message, {
      nzKey: this.createKey(title + message),
      nzDuration: duration
    });
  }

  show(title, message?, duration = this.duration) {
    return this.notification.blank(title, message, {
      nzKey: this.createKey(title + message),
      nzDuration: duration
    });
  }

  template(template: any, data: NzNotificationDataOptions): NzNotificationRef {
    return this.notification.template(template, {
      nzKey: data.nzKey,
      nzDuration: data.nzDuration || data.nzDuration === 0 ? data.nzDuration : this.duration,
      nzPlacement: data.nzPlacement || 'topRight',
      nzStyle: data.nzStyle || {}
    });
  }

  templateNoCloseIcon(template: any, data: NzNotificationDataOptions): NzNotificationRef {
    return this.notification.template(template, {
      nzKey: data.nzKey,
      nzDuration: data.nzDuration || data.nzDuration === 0 ? data.nzDuration : this.duration,
      nzCloseIcon: '',
      nzPlacement: data.nzPlacement || 'topRight',
      nzStyle: data.nzStyle || {}
    });
  }

  createKey(message: string): string {
    const timestamp = moment().format('YYYYMMDDHHmmssSSS');
    return (message || timestamp).replace(' ', '_');
  }
}
